import { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => {
    // Default is ALWAYS dark. Light mode only activates if the reader has
    // explicitly chosen it via the theme toggle (and we persisted that
    // choice in localStorage). System preference (prefers-color-scheme)
    // is intentionally ignored — the platform brand experience is dark.
    const saved = localStorage.getItem('spicy-theme');
    if (saved === 'light' || saved === 'dark') return saved;
    return 'dark';
  });

  useEffect(() => {
    const root = window.document.documentElement;
    
    // Remove both classes first
    root.classList.remove('light', 'dark');
    
    // Add the current theme class
    root.classList.add(theme);
    
    // Save to localStorage
    localStorage.setItem('spicy-theme', theme);
    
    // Update body background for smooth transitions
    if (theme === 'light') {
      document.body.style.backgroundColor = '#f8f5f2';
    } else {
      document.body.style.backgroundColor = '#050505';
    }
  }, [theme]);

  const toggleTheme = () => {
    setTheme(prev => prev === 'dark' ? 'light' : 'dark');
  };

  const isDark = theme === 'dark';

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme, isDark }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}
